import { render, staticRenderFns } from "./Wineries.vue?vue&type=template&id=46dfcc25&"
import script from "./Wineries.vue?vue&type=script&lang=js&"
export * from "./Wineries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports